import React from 'react';
import { Switch, Route } from 'react-router-dom';
// import Home from './Home';
import Devices from './Devices';
import DeviceDetail from './DeviceDetail';

const App = () => (
  <Switch>
    <Route exact path="/:user" component={Devices} />
    <Route exact path="/:user/:deviceId" component={DeviceDetail} />
  </Switch>
);

export default App;
